window.$ = require('jquery');
require('lity/dist/lity');
